// Shared constants for the service-api layer. Kept free of client-only code
// so both the 'use client' hooks and server route handlers can import it.

// Request header carrying the test-page mail override (see setServiceMailOverride).
export const OVERRIDE_HEADER = 'x-service-mail-override';
